import React, { useState, useEffect } from "react";
import style from "./NavigationMobile.module.scss";
import Button from "../../elements/Buttons/Button";
import { Link } from "gatsby";
import cx from "classnames";
import onClickOutside from "react-onclickoutside";

function NavigationMobile({ contattiCallBack }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrolled(window.scrollY > 0);
    });
  }, []);

  NavigationMobile.clickOutside = () => setOpen(false);

  return (
    <div className={cx(style.navigation, { [style.scrolled]: scrolled && !open })}>
      <div className={cx(style.container)}>

        <div className={style.logo} />
        {contattiCallBack && (
          <Button outline onClick={() => contattiCallBack()}>
            Contattaci
          </Button>
        )}
        {/* eslint-disable-next-line */}
        <div className={style.burger} onClick={() => setOpen(prev => !prev)} />
      </div>
      <div className={cx(style.menu, { [style.open]: open })}>
        <Link to={"/"}>Home.</Link>
        <Link to={"/chi-siamo"}>Chi siamo.</Link>
        <Link to={"/cosa-facciamo"}>Cosa facciamo.</Link>
        <Link to={"/assicurativo"}>Piattaforma assicurativa.</Link>
        <Link to={"/affiliati"}>Programma Affiliati.</Link>
      </div>
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: () => NavigationMobile.clickOutside,
};

export default onClickOutside(NavigationMobile, clickOutsideConfig);
